import { css } from 'linaria';
import fonts from 'style/fonts';
export const icon = "i1d0jsls";
export const vimeo = "v1ea8i1u";
export const poster = "p4s3y55";
export const player = "povs9ry";

require("/Users/florianmorel/Work/Websites/rudy-vermorel-2019/.linaria-cache/src/components/vimeo-player/styles.linaria.css");